import React from "react"
import CookieConsent from "react-cookie-consent"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Navigation from "./navigation"
import Header from "./header"
import Footer from "./footer"

import "bootstrap/dist/css/bootstrap.min.css"
import "../sass/layout.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Navigation />
      <Header siteTitle={data.site.siteMetadata.title} />
      <main>{children}</main>
      <Footer />
      <CookieConsent
        location="bottom"
        enableDeclineButton
        flipButtons
        buttonText="J'accepte"
        declineButtonText="Je refuse"
        cookieName="gatsby-gdpr-google-analytics"
        disableStyles={true}
        containerClasses="fixed-bottom d-lg-flex justify-content-lg-between alert alert-warning m-0"
        contentClasses="my-2"
        buttonClasses="btn btn-purple mx-1"
        declineButtonClasses="btn btn-secondary mx-1"
      >
        Ce site utilise des cookies afin de récolter des données d'utilisation
        et d'améliorer l'expérience du site.{" "}
        <Link to="/politique-confidentialite">En savoir plus</Link>
      </CookieConsent>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
